import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { BrokerModel, SupplierBrokerModel, SupplierModel } from '../../../../api/admin/admin.types';
import { PageRequest } from '../../../../api/api.types';
import { AppState } from '../../../../store/store.types';
import { ThunkDispatch } from 'redux-thunk';
import { BrokerActionTypes } from '../../types/broker.types';
import { getBrokerList } from '../../actions/broker.actions';
import React from 'react';
import { getSupplierBrokerList } from '../../actions/supplierbroker.actions';
import StatusLabel from '../../../../components/forms/StatusLabel';
import { Link } from 'react-router-dom';
import ListViewTable from '../../../../components/tables/ListViewTable';
import JsonModal from '../../../../components/modals/JsonModal';
import { connect } from 'react-redux';

interface SupplierBrokerProps extends RouteComponentProps, WithTranslation {
  getSupplierBrokers: (pageRequest?: PageRequest) => void;
  brokers: BrokerModel[] | null;
  supplierBrokers: SupplierBrokerModel[] | null;
  activeSupplier: SupplierModel | null;
  totalPages: number;
  totalElements: number;
}

interface SupplierBrokerState {
  selectedPageNumber: number;
  sortOrder: 'ASC' | 'DESC';
  sortedBy: string;
  modalOpen: boolean;
  modalData: any;
  modalTitle: string;
}

class SupplierBrokers extends React.Component<SupplierBrokerProps, SupplierBrokerState> {
  constructor(props: SupplierBrokerProps) {
    super(props);
    this.state = {
      selectedPageNumber: 1,
      sortOrder: 'ASC',
      sortedBy: 'name',
      modalOpen: false,
      modalData: {},
      modalTitle: ''
    };
  }

  componentDidMount() {
    this.props.getSupplierBrokers();
  }

  statusCell = (props: any) => (<StatusLabel status={props}/>);

  additionalDataCell = (props: any) => {
    return (
      <button type="button" className="btn btn-link font-normal p-0" onClick={() => {
        this.setState({
          modalData: {
            'Agent id': props.agentId,
            'Company id': props.companyId,
            'Referral id': props.referralId,
            'Source code': props.sourceCode
          },
          modalOpen: true,
          modalTitle: 'Additional data'
        });
      }}>
        View value
      </button>);
  };

  onCellClick = (cellInfo: any) => {
    if (cellInfo.column.id !== 'additionalData') {
      return (this.props.history.push(`/admin/brokers/${cellInfo.row.original.id}/view`));
    }
  };

  defineColumns() {
    const { t } = this.props;
    return [
      {
        header: t('ct.supplier_brokers.name'), accessorKey: 'name', id: 'name'
      },
      {
        header: t('ct.brokers.legal_name'), accessorKey: 'legalName', id: 'legalName'
      },
        {
            header: 'Supplier reference code', accessorKey: 'supplierReferenceCode', id: 'supplierReferenceCode'
        },
      {
        header: t('ct.brokers.comment'), accessorKey: 'comment', id: 'comment'
      },
      {
        header: t('ct.supplier_brokers.status_type'),
        accessorKey: 'statusType',
        id: 'statusType',
        cell: (info: any) => this.statusCell(info.getValue())
      },
      {
        header: t('ct.supplier_brokers.additional_data'),
        accessorKey: 'additionalData',
        id: 'additionalData',
        cell: (info: any) => this.additionalDataCell(info.getValue())
      }
    ];
  }

  render() {

    const { t } = this.props;
    return (
      <main>
        <div className="page-content">
          <div className="d-flex justify-content-between align-items-center mt-2 mb-1">
            <h1>{t('page_title.supplier_brokers')}</h1>
            <Link
              to={{
                pathname: '/admin/brokers/create'
              }}
              className="btn btn-primary btn-wide"
            >
              {t('b.add_new').toUpperCase()}
            </Link>
          </div>
          {this.props.supplierBrokers?.length ? (
            <div className="table-list">
              <ListViewTable
                data={this.props.supplierBrokers}
                columns={this.defineColumns()}
                onCellClickFn={this.onCellClick}/>
            </div>
          ) : ''}
        </div>
        <JsonModal
          content={this.state.modalData}
          isOpen={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
          toggle={() => this.setState({ modalOpen: false })}
          title={this.state.modalTitle}
        />
      </main>

    );
  }
}

const
  mapStateToProps = (state: AppState) => ({
    supplierBrokers: state.admin.supplierBrokers.supplierBrokers,
    brokers: state.admin.brokers.brokers,
    activeSupplier: state.authentication.activeSupplier,
    totalPages: state.admin.classifiers.totalPages,
    totalElements: state.admin.classifiers.totalElements
  });

const
  mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, BrokerActionTypes>) => ({
    getBrokerList: (pageRequest?: PageRequest) => dispatch(getBrokerList(pageRequest)),
    getSupplierBrokers: (pageRequest?: PageRequest) => dispatch(getSupplierBrokerList(pageRequest))
  });

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SupplierBrokers));